<!-- En-tête de page (#1082, #1083) : indicateur de modifications, enregistrement, menu « Autres actions ». -->
<ng-template appEnteteActions>
  <app-etat-saisie [form]="form" />
  <button type="button" class="btn btn-primary position-relative" [disabled]="!form.dirty || saving" (click)="save()">
    @if (saving) {
      <app-button-spinner></app-button-spinner>
    }
    Enregistrer
  </button>
  <button type="button" class="btn btn-outline-primary" [cdkMenuTriggerFor]="popupBarAssociationActiviteMembres.menu">
    Autres actions
    <i class="material-icons md-18" aria-hidden="true">arrow_drop_down</i>
  </button>
</ng-template>
<app-association-activite-membres-popup></app-association-activite-membres-popup>

<div [formGroup]="form" class="fiche" [class.fiche--lecture]="readonly">
  <app-fiche-bandeau [etat]="editor.erreursFiche" [lectureSeule]="readonly" />

  <app-bloc titre="Activité">
    <div class="fiche-grille">
      <app-control codeLabel="activite" class="l2">
        <ng-select
          #select
          [items]="activiteSearchor.buffer"
          [virtualScroll]="true"
          [loading]="activiteSearchor.loading"
          bindLabel="label"
          [typeahead]="activiteSearchor.input$"
          (scroll)="activiteSearchor.onScroll($event)"
          placeholder="Sélectionner une activité"
          formControlName="id"
          bindValue="id"
          (change)="onActiviteChange()"
        >
        </ng-select>
      </app-control>
      <app-control codeLabel="debutActivite">
        <app-date-input formControlName="debutAct" [title]="alertModifParFicheActivite()"></app-date-input>
      </app-control>
      <app-control codeLabel="finActivite">
        <app-date-input [colorSiDateEchue]="true" formControlName="finAct" [title]="alertModifParFicheActivite()"></app-date-input>
      </app-control>
      <div class="fiche-cases l4">
        <label class="cursor" [title]="alertModifParFicheActivite()">
          <input type="checkbox" formControlName="miseEnSommeilSage" />
          Mise en sommeil Sage
        </label>
      </div>
    </div>
  </app-bloc>

  <app-bloc titre="Membres associés à l'activité">
    <div class="fiche-bloc-corps">
      <app-list
        [readOnly]="readonly"
        formControlName="activiteMembreList"
        [newElement]="newAssoDto"
        [eltName]="'Membre'"
        [nbEltsMax]="30"
        [resume]="resumeAsso"
        [consigne]="consigne"
        [avecCard]="false"
        [collapsible]="false"
        [pushDisabled]="!form.valid"
        [eltNonSupprimable]="assoNonSupprimable"
        (tryToDelete)="alertAssoNonSupprimable()"
      >
        <ng-template let-ctrl="ctrl" let-new="new" let-idx="idx">
          <app-saisie-membre-activite
            [formControl]="ctrl"
            [readOnly]="readonly"
            [consigne]="consigne"
            [deplie]="new"
            [activiteDonnee]="true"
            [membreExclusion]="membreAssocieList"
          ></app-saisie-membre-activite>
        </ng-template>
      </app-list>
    </div>
  </app-bloc>
</div>
